import styled from 'styled-components';

export const ReportsNestedTableBodyCont = styled.div`
  position: relative;
  min-height: 90px;
`;
